import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Pipe({
  name: 'contentHiking'
})

export class HikingPipe implements PipeTransform {

  constructor() {
  }

  transform(entry: Models.ContentEntry): Models.HikingAreaEntry {
    if (!entry || !entry.detail || !entry.detail.slopes) {
      return null;
    }
    const hikingArea = new Models.HikingAreaEntry();

    const hikingTrails: Models.HikingTrailEntry[] = [];

    for (const rawHikingTrail of entry.detail.slopes) {

      const hikingTrail = new Models.HikingTrailEntry();
      hikingTrail.populateFromJSON({
        id: rawHikingTrail.id,
        title: rawHikingTrail.title,
        statusId: rawHikingTrail.status,
        length: rawHikingTrail.length
      });

      hikingTrails.push(hikingTrail);
    }

    if (hikingTrails.length === 0) {
      return null;
    }

    hikingArea.populateFromJSON({
      sourceId: entry._id,
      trails: hikingTrails
    });

    return hikingArea;
  }

}
